module.exports = __webpack_public_path__ + "media/images/logo/ekuitas-secure-1672676f52e9e00099b5820bbd0486a5.svg";